export var ImpactType;
(function (ImpactType) {
    ImpactType[ImpactType["NoImpact"] = 1] = "NoImpact";
    ImpactType[ImpactType["Minor"] = 2] = "Minor";
    ImpactType[ImpactType["Moderate"] = 3] = "Moderate";
    ImpactType[ImpactType["Major"] = 4] = "Major";
    ImpactType[ImpactType["Huge"] = 5] = "Huge";
})(ImpactType || (ImpactType = {}));
